export default {
  isMenuOpen: false,
  isAppMenuOpen: false,
  isNavigationCollapsed: false,
  isModalOpen: false,
  isOwnershipFull: false,
};
